export default "__VITE_ASSET__CdhGuqoC__"